// extracted by mini-css-extract-plugin
export default {"formTitle":"AgreementInfoCard_formTitle__0Bfxo","contentContainer":"AgreementInfoCard_contentContainer__29ip+"};